'use client';

import type { ClassValue } from 'clsx';

import { GlossaryIndexError, GlossaryIndexNoticeMessage } from '@vs-shop/commerce-ui/glossaryIndex';
import { Button } from '@vs-shop/ui/button';
import { clsxm } from '@vs-shop/utils';
import { useIntl } from 'react-intl';

type Props = {
  onRetry: () => void;
  className?: ClassValue;
};

/**
 * Shown when a glossary read fails. A failed request is not an empty result —
 * presenting one as the other tells the user the catalogue is empty when the
 * backend is merely unreachable, and offers no way back.
 */
export function GlossaryLoadError({ onRetry, className }: Props) {
  const intl = useIntl();

  return (
    <GlossaryIndexError className={clsxm(className)}>
      <GlossaryIndexNoticeMessage>
        {intl.formatMessage({
          id: 'component.client.page.glossary.error.message',
          defaultMessage: 'Pojmy se nepodařilo načíst.',
        })}
      </GlossaryIndexNoticeMessage>
      <Button onClick={onRetry}>
        {intl.formatMessage({
          id: 'component.client.page.glossary.error.retry',
          defaultMessage: 'Zkusit znovu',
        })}
      </Button>
    </GlossaryIndexError>
  );
}
